<template>
  <div class="HomePresentation" id="HomePresentation">
    <div class="HomePresentation-Background">
      <div class="HomePresentation-Background-Opacity"></div>
      <div class="HomePresentation-Text">
        <Title class="jobstream">JobStream</Title>
        <Title type="small">vous accompagne dans vos projets</Title>
        <Paragraph>
          <p>
            <strong>JobStream</strong> accompagne les TPE/PME dans la gestion de leurs ressources humaines (RH).
          </p>
          <p>
            Cette prestation de conseil permet à l'entreprise, de bénéficier d'un accompagnement personnalisé et
            favorise une gestion RH bien maîtrisée.
          </p>
        </Paragraph>
        <div class="HomePresentation-Button">
          <router-link to="/conseil/accompagnement" @click.native="$scrollToTop();">
            <Animation>
              <Button>Voir plus</Button>
            </Animation>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePresentation"
}
</script>

<style scoped>

.HomePresentation {
}

.jobstream >>> span div {
  text-transform: none;
}


.HomePresentation ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.HomePresentation li {
  text-transform: uppercase;
  font-size: 12px;
  font-family: 'GothamBold', sans-serif;
  color: var(--colorLigher);
}

/*
* Background
*/
.HomePresentation-Background {
  padding: 100px 0;
  background: no-repeat url('/img/home/presentation.jpg');
  background-position: center;
  background-size: cover;
  position: relative;
}

.HomePresentation-Background-Opacity {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.HomePresentation--containerButton {
  margin: auto
}

.HomePresentation-Button {
  text-align: center;
  margin: auto;
}

.HomePresentation-Button a {
  display: inline-block;
}

.HomePresentation-Button >>> .Button {
  text-align: center;
  margin: auto;
  width: 100px;
}

a {
  text-decoration: none;
  color: white;
}

.HomePresentation-Text {
  position: relative;
  text-align: center;
  max-width: 800px;
  margin: auto;
}

.HomePresentation-Text >>> .Paragraph {
  margin: auto;
  max-width: 1200px;
  color: #FFFFFF;
  padding: 50px 25px;
}

.HomePresentation >>> .Title-small span {
  color: #ffffff;
}

.HomePresentation >>> .Title-big span {
  color: #ffffff;
}
</style>